import React from 'react';
import EventDocumentBody from './eventDocumentBody.component';
import { FileIcon, UUID } from '@umanforge/common';
import { EventDocument } from 'interfaces/document.interface';


interface EventDocumentOtherProps {
  file: EventDocument;
  canDelete: boolean;
  isDeleted: boolean;
  isViewMode?: boolean;
  deleteFile: ( fileId: UUID ) => void;
}

const EventDocumentOther: React.FC<EventDocumentOtherProps> = ( { file, canDelete, isDeleted, isViewMode, deleteFile } ) => {
  return (
    <EventDocumentBody
      file={ file }
      isViewMode={ isViewMode }
      canDelete={ canDelete }
      isDeleted={ isDeleted }
      deleteFile={ deleteFile }
    >
      <FileIcon
        className={`
          w-full h-full
          flex 
          px-4 py-0.5
          sm:px-5 sm:py-1
          md:px-6 md:py-2
          justify-center 
        `}
      />
    </EventDocumentBody>
  );
};

export default EventDocumentOther;
